<template>
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.8138 0C18.721 0 0.805664 17.9072 0.805664 40C0.805664 62.0928 18.7128 80 40.8057 80C42.5402 80 44.2421 79.8779 45.9115 79.6661C53.2242 78.7296 59.9099 75.8306 65.4392 71.5065C74.7877 64.1857 80.8057 52.8013 80.8057 40C80.8138 17.9072 62.9066 0 40.8138 0Z"
      fill="#9999FF"
    />
    <mask
      id="mask0_1372_18750"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="81"
      height="80"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.8138 0C18.721 0 0.805664 17.9072 0.805664 40C0.805664 62.0928 18.7128 80 40.8057 80C42.5402 80 44.2421 79.8779 45.9115 79.6661C53.2242 78.7296 59.9099 75.8306 65.4392 71.5065C74.7877 64.1857 80.8057 52.8013 80.8057 40C80.8138 17.9072 62.9066 0 40.8138 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1372_18750)">
      <circle cx="49.2829" cy="25.2119" r="17.5896" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.8789 25.2118C30.8789 15.0652 39.1362 6.80786 49.2828 6.80786C59.4294 6.80786 67.6867 15.0652 67.6867 25.2118C67.6867 35.3584 59.4294 43.6157 49.2828 43.6157C39.1362 43.6157 30.8789 35.3584 30.8789 25.2118ZM66.0583 25.2118C66.0583 15.9447 58.5502 8.43657 49.2831 8.43657C40.016 8.43657 32.5078 15.9447 32.5078 25.2118C32.5078 34.4789 40.016 41.9871 49.2831 41.9871C58.5502 41.9871 66.0583 34.4789 66.0583 25.2118Z"
        fill="#CCCCCC"
      />
      <circle
        cx="60.3061"
        cy="14.1406"
        r="0.635179"
        transform="rotate(-49.57 60.3061 14.1406)"
        fill="#0CC988"
      />
      <circle cx="49.2831" cy="9.55242" r="0.635179" fill="#003E1A" />
      <circle cx="49.2831" cy="40.7983" r="0.635179" fill="#003E1A" />
      <circle cx="55.4804" cy="10.839" r="0.635179" fill="#003E1A" />
      <circle cx="43.078" cy="39.5197" r="0.635179" fill="#003E1A" />
      <circle cx="64.9023" cy="25.1794" r="0.635179" fill="#003E1A" />
      <circle cx="33.6562" cy="25.1794" r="0.635179" fill="#003E1A" />
      <circle cx="63.7621" cy="31.0749" r="0.635179" fill="#003E1A" />
      <circle cx="34.8046" cy="19.3405" r="0.635179" fill="#003E1A" />
      <circle
        cx="60.3246"
        cy="36.2234"
        r="0.635179"
        transform="rotate(-31.1 60.3246 36.2234)"
        fill="#003E1A"
      />
      <circle
        cx="38.2362"
        cy="14.133"
        r="0.635179"
        transform="rotate(-31.1 38.2362 14.133)"
        fill="#003E1A"
      />
      <circle
        cx="55.4568"
        cy="39.5233"
        r="0.635179"
        transform="rotate(-20.39 55.4568 39.5233)"
        fill="#003E1A"
      />
      <circle
        cx="43.1311"
        cy="10.8133"
        r="0.635179"
        transform="rotate(-20.39 43.1311 10.8133)"
        fill="#003E1A"
      />
      <circle
        cx="38.2109"
        cy="36.2382"
        r="0.635179"
        transform="rotate(-49.57 38.2109 36.2382)"
        fill="#003E1A"
      />
      <circle
        cx="35.0115"
        cy="31.5401"
        r="0.635179"
        transform="rotate(-38.71 35.0115 31.5401)"
        fill="#003E1A"
      />
      <circle
        cx="63.6014"
        cy="18.9341"
        r="0.635179"
        transform="rotate(-38.71 63.6014 18.9341)"
        fill="#003E1A"
      />
      <circle cx="52.3041" cy="9.84538" r="0.635179" fill="#003E1A" />
      <circle cx="46.3105" cy="40.5051" r="0.635179" fill="#003E1A" />
      <circle cx="58.143" cy="12.2885" r="0.635179" fill="#003E1A" />
      <circle cx="40.4721" cy="38.0619" r="0.635179" fill="#003E1A" />
      <circle cx="64.6415" cy="28.176" r="0.635179" fill="#003E1A" />
      <circle cx="33.9736" cy="22.1745" r="0.635179" fill="#003E1A" />
      <circle
        cx="62.3899"
        cy="33.7487"
        r="0.635179"
        transform="rotate(-44.27 62.3899 33.7487)"
        fill="#003E1A"
      />
      <circle
        cx="36.2214"
        cy="16.666"
        r="0.635179"
        transform="rotate(-44.27 36.2214 16.666)"
        fill="#003E1A"
      />
      <circle
        cx="58.0247"
        cy="38.1326"
        r="0.635179"
        transform="rotate(-22.18 58.0247 38.1326)"
        fill="#003E1A"
      />
      <circle
        cx="40.5887"
        cy="12.2136"
        r="0.635179"
        transform="rotate(-22.18 40.5887 12.2136)"
        fill="#003E1A"
      />
      <circle
        cx="52.6259"
        cy="40.4331"
        r="0.635179"
        transform="rotate(-10.48 52.6259 40.4331)"
        fill="#003E1A"
      />
      <circle
        cx="46.0233"
        cy="9.89479"
        r="0.635179"
        transform="rotate(-10.48 46.0233 9.89479)"
        fill="#003E1A"
      />
      <circle
        cx="36.324"
        cy="33.9101"
        r="0.635179"
        transform="rotate(-37.63 36.324 33.9101)"
        fill="#003E1A"
      />
      <circle
        cx="62.2527"
        cy="16.4685"
        r="0.635179"
        transform="rotate(-37.63 62.2527 16.4685)"
        fill="#003E1A"
      />
      <circle
        cx="33.976"
        cy="28.4539"
        r="0.635179"
        transform="rotate(-26.93 33.976 28.4539)"
        fill="#003E1A"
      />
      <circle
        cx="64.5556"
        cy="21.7896"
        r="0.635179"
        transform="rotate(-26.93 64.5556 21.7896)"
        fill="#003E1A"
      />
      <rect
        x="39.1445"
        y="20.782"
        width="8.68078"
        height="10.2443"
        fill="#ECEBEB"
      />
      <rect
        x="49.3726"
        y="20.7898"
        width="10.5375"
        height="1.5798"
        fill="#ECEBEB"
      />
      <rect
        x="49.3726"
        y="23.2246"
        width="10.5375"
        height="1.5798"
        fill="#ECEBEB"
      />
      <rect
        x="49.3726"
        y="27.158"
        width="10.5375"
        height="1.5798"
        fill="#0CC988"
      />
      <path
        d="M61.8565 60.464L51.0503 57.8419C50.1546 57.622 49.2506 58.1758 49.0308 59.0715C48.8109 59.9673 49.3646 60.8631 50.2523 61.0829L53.3386 61.8321L47.3695 63.8028L41.6692 61.9706C40.9689 61.7425 40.2116 62.1334 39.9835 62.8337C39.7555 63.5341 40.1464 64.2914 40.8467 64.5194L47.3777 66.6204L56.9217 63.4771C57.2392 63.3712 57.4998 63.1513 57.6546 62.8826L61.0666 63.7051C61.9624 63.9249 62.8663 63.3712 63.0861 62.4754C63.306 61.5797 62.7523 60.6839 61.8646 60.464H61.8565Z"
        fill="#AE6E3E"
      />
      <path
        d="M47.5808 67.1744C47.8088 67.2314 48.0531 67.2314 48.2893 67.1744L62.0596 63.5262C62.8251 63.3226 63.2811 62.5409 63.0776 61.7754C62.874 61.0099 62.0922 60.5539 61.3267 60.7575L48.0938 64.2591L43.5417 61.8487C42.8414 61.4822 41.9701 61.7428 41.6036 62.4432C41.2372 63.1435 41.4978 64.0148 42.1981 64.3813L47.2388 67.0523C47.3447 67.1093 47.4505 67.15 47.5645 67.1744H47.5808Z"
        fill="#D4916D"
      />
      <path
        d="M69.1284 60.2526H61.6773C61.6773 60.2526 61.661 60.2526 61.6529 60.2526C61.433 60.2526 61.2294 60.2852 61.0258 60.3422C60.9851 60.3503 60.9362 60.3666 60.8955 60.3829L48.9004 64.6907L45.2033 61.9464C44.6822 61.5637 43.9574 61.6696 43.5747 62.1907C43.1919 62.7038 43.2978 63.4367 43.819 63.8194L48.1757 67.0523C48.2571 67.1093 48.3385 67.15 48.4281 67.1907C48.477 67.2152 48.534 67.2396 48.591 67.2559C48.6887 67.2966 48.9574 67.3454 49.1203 67.3129C49.1854 67.3047 49.2506 67.2966 49.3239 67.2722L62.1252 64.8862C62.1822 64.878 62.2392 64.8617 62.2962 64.8373H69.1203C69.1203 64.8373 69.1366 64.8373 69.1447 64.8373C70.4069 64.821 71.4167 63.795 71.4167 62.5327C71.4167 61.2624 70.3825 60.2363 69.1121 60.2363L69.1284 60.2526Z"
        fill="#F8C797"
      />
      <rect
        x="64.585"
        y="60.1711"
        width="4.15309"
        height="6.65309"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.1626 65.7167C65.1626 66.018 65.4069 66.2623 65.7082 66.2623C66.0095 66.2623 66.2538 66.018 66.2538 65.7167C66.2538 65.4154 66.0095 65.1711 65.7082 65.1711C65.4069 65.1711 65.1626 65.4154 65.1626 65.7167ZM65.6842 65.839C65.6842 65.8878 65.6435 65.9285 65.5946 65.9285C65.5458 65.9285 65.5051 65.8878 65.5051 65.839C65.5051 65.7901 65.5458 65.7494 65.5946 65.7494C65.6435 65.7494 65.6842 65.7901 65.6842 65.839ZM65.8226 65.676C65.8715 65.676 65.9122 65.6353 65.9122 65.5864C65.9122 65.5376 65.8715 65.4968 65.8226 65.4968C65.7738 65.4968 65.7331 65.5376 65.7331 65.5864C65.7331 65.6353 65.7738 65.676 65.8226 65.676Z"
        fill="#FF6800"
      />
      <path
        d="M79.2996 60.0977L79.324 68.5993H66.6856L66.6611 60.0977H79.2996Z"
        fill="#D5CBE7"
      />
      <path
        d="M12.4916 44.7313C12.4916 44.7313 12.4916 44.7313 12.4997 44.7313L27.1007 41.1971C28.314 40.9039 29.5355 41.645 29.8287 42.8583C30.1219 44.0635 29.3808 45.285 28.1756 45.5782C28.1756 45.5782 28.1756 45.5782 28.1675 45.5782L24.0062 46.588L32.0681 49.2427L39.7635 46.759C40.7163 46.4495 41.7342 46.9788 42.0355 47.9235C42.345 48.8762 41.8157 49.8942 40.871 50.1955L32.0518 53.0375L19.1609 48.7948C18.7293 48.6482 18.3873 48.3632 18.1675 47.9968L13.5665 49.1124C12.3531 49.4056 11.1398 48.6645 10.8385 47.4512C10.5453 46.2459 11.2863 45.0244 12.4916 44.7313Z"
        fill="#AE6E3E"
      />
      <rect
        x="32.9971"
        y="36.1748"
        width="6.74267"
        height="0.969055"
        transform="rotate(-80.69 32.9971 36.1748)"
        fill="#00D078"
      />
      <rect
        x="29.7153"
        y="37.0432"
        width="11.6124"
        height="0.969055"
        transform="rotate(-85.81 29.7153 37.0432)"
        fill="#00D078"
      />
      <rect
        x="24.1719"
        y="23.561"
        width="0.969055"
        height="14.772"
        transform="rotate(-11.23 24.1719 23.561)"
        fill="#00D078"
      />
      <circle cx="28.3541" cy="30.8878" r="1.40879" fill="#FF7200" />
      <circle cx="22.2389" cy="28.8763" r="1.40879" fill="#FF7200" />
      <circle cx="24.1769" cy="22.0033" r="1.40879" fill="#FF7200" />
      <circle cx="30.6998" cy="23.4364" r="1.40879" fill="#FF7200" />
      <circle cx="34.8531" cy="28.3551" r="1.40879" fill="#FF7200" />
      <rect
        x="28.0186"
        y="32.5918"
        width="0.969055"
        height="5.02443"
        transform="rotate(-1.86 28.0186 32.5918)"
        fill="#00D078"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.1069 32.0114L25.2681 31.7834L25.26 31.7753C24.975 31.6938 24.7632 31.4414 24.7469 31.1401C24.7225 30.8469 24.8935 30.5619 25.1704 30.4398L25.9684 30.0896L25.545 29.3323C25.3984 29.0717 25.431 28.7459 25.6264 28.5179C25.8219 28.2899 26.1476 28.2085 26.4245 28.3225L27.2388 28.6401L27.4668 27.8013C27.5482 27.5082 27.8007 27.2964 28.102 27.2801C28.4033 27.2557 28.6802 27.4267 28.8023 27.7036L29.1525 28.5016L29.9017 28.07C30.1623 27.9235 30.488 27.956 30.716 28.1515C30.944 28.3469 31.0254 28.6727 30.9114 28.9495L30.5938 29.7639L31.4326 29.9919C31.7258 30.0733 31.9375 30.3257 31.9538 30.6271C31.9782 30.9284 31.8072 31.2052 31.5303 31.3274L30.7323 31.6775L31.1557 32.4349C31.3023 32.6955 31.2697 33.0212 31.0743 33.2492C30.8789 33.4772 30.5613 33.5505 30.2763 33.4446L29.4619 33.127L29.2339 33.9658C29.1688 34.2101 28.9815 34.3974 28.7535 34.4626C28.7046 34.4788 28.6557 34.4951 28.6069 34.4951C28.3137 34.5196 28.0287 34.3485 27.9066 34.0717L27.5564 33.2736L26.7991 33.7052C26.5385 33.8518 26.2127 33.8192 25.9847 33.6238C25.7567 33.4284 25.6753 33.1026 25.7893 32.8257L26.1069 32.0114ZM27.4601 30.9353C27.4568 30.9385 27.4534 30.9416 27.4501 30.9446V30.9283C27.4534 30.9307 27.4568 30.933 27.4601 30.9353ZM27.4601 30.9353C27.5611 31.0073 27.6389 31.0945 27.6862 31.1971C27.7351 31.3029 27.7595 31.4251 27.7595 31.5472C27.8735 31.5309 27.9957 31.5309 28.1097 31.5717C28.2237 31.6124 28.3295 31.6775 28.411 31.7671C28.4843 31.6694 28.5738 31.5879 28.6797 31.5391C28.7123 31.5228 28.7611 31.5065 28.7937 31.4984C28.867 31.4739 28.9484 31.4739 29.0217 31.4739C29.0054 31.3599 29.0136 31.2378 29.0462 31.1238C29.0869 31.0098 29.152 30.9039 29.2416 30.8225C29.1357 30.7492 29.0543 30.6596 29.0054 30.5537C28.9647 30.4397 28.9403 30.3176 28.9403 30.2036C28.8263 30.2199 28.7041 30.2199 28.5901 30.1791C28.4761 30.1384 28.3703 30.0733 28.2888 29.9837C28.2237 30.0896 28.126 30.171 28.0201 30.2199C27.9142 30.2687 27.7921 30.2932 27.6699 30.2932C27.6862 30.4072 27.6781 30.5293 27.6455 30.6433C27.6063 30.753 27.5445 30.8552 27.4601 30.9353Z"
        fill="#5B2692"
      />
      <rect
        x="22.1265"
        y="30.4946"
        width="0.969055"
        height="5.5456"
        transform="rotate(-13.45 22.1265 30.4946)"
        fill="#00D078"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7553 29.0798L19.0224 28.6074H19.0387C18.7862 28.4364 18.6641 28.1351 18.7374 27.842C18.8107 27.5488 19.055 27.3289 19.3563 27.2964L20.2195 27.2068L20.0403 26.3517C19.9833 26.0586 20.1136 25.7573 20.366 25.6026C20.6266 25.4478 20.9524 25.4723 21.1885 25.6596L21.8644 26.2052L22.3367 25.4723C22.4996 25.2198 22.8009 25.0977 23.094 25.171C23.3872 25.2443 23.6071 25.4886 23.6397 25.7899L23.7292 26.6531L24.5761 26.4739C24.8693 26.4169 25.1706 26.5472 25.3253 26.7996C25.48 27.0602 25.4556 27.3859 25.2683 27.6221L24.7227 28.298L25.4556 28.7703C25.7081 28.9332 25.8302 29.2345 25.7569 29.5276C25.6836 29.8208 25.4393 30.0407 25.138 30.0732L24.2748 30.1628L24.454 31.0179C24.511 31.311 24.3807 31.6123 24.1283 31.7671C23.8677 31.9218 23.5419 31.8973 23.3058 31.7101L22.6299 31.1645L22.1576 31.8973C22.0191 32.1091 21.7911 32.2231 21.5468 32.2231C21.4898 32.2231 21.441 32.2149 21.3921 32.2068L21.3921 32.2068C21.0989 32.1335 20.8791 31.8892 20.8465 31.5879L20.7569 30.7247L19.9019 30.9039C19.6087 30.9609 19.3074 30.8306 19.1527 30.5781C18.998 30.3175 19.0224 29.9918 19.2097 29.7557L19.7553 29.0798ZM21.3805 28.4753C21.379 28.476 21.3774 28.4767 21.3759 28.4773V28.4692C21.3774 28.4712 21.379 28.4733 21.3805 28.4753ZM21.3805 28.4753C21.4512 28.5713 21.4984 28.6753 21.5143 28.7949C21.5306 28.9171 21.5225 29.0392 21.4818 29.1532C21.5958 29.1695 21.7098 29.2102 21.8075 29.2835C21.9052 29.3568 21.9866 29.4464 22.0355 29.5604C22.1332 29.4871 22.2391 29.4382 22.3612 29.4219H22.4834C22.5648 29.4219 22.6381 29.4382 22.7114 29.4627C22.7277 29.3486 22.7766 29.2346 22.8417 29.1369C22.915 29.0392 23.0046 28.9578 23.1186 28.9089C23.0453 28.8112 22.9964 28.7053 22.9801 28.5832C22.972 28.4529 22.9801 28.3307 23.0209 28.2249C22.9068 28.2086 22.7928 28.1679 22.6951 28.0946C22.5974 28.0213 22.516 27.9317 22.4671 27.8177C22.3775 27.891 22.2635 27.9399 22.1414 27.9561C22.0192 27.9724 21.8971 27.9643 21.7831 27.9236C21.7668 28.0376 21.7179 28.1516 21.6528 28.2493C21.5805 28.3457 21.4923 28.4263 21.3805 28.4753Z"
        fill="#5B2692"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.428 23.8764L27.687 23.4204C27.4427 23.2575 27.3124 22.9562 27.3775 22.663C27.4427 22.3699 27.6788 22.15 27.9801 22.1093L28.8433 22.0034L28.6479 21.1565C28.5827 20.8634 28.7049 20.5621 28.9573 20.3992C29.2098 20.2445 29.5436 20.2526 29.7798 20.4399L30.4638 20.9774L30.9199 20.2363C31.0827 19.9839 31.384 19.8536 31.6772 19.9187C31.9704 19.992 32.1902 20.2282 32.2309 20.5295L32.3368 21.3927L33.1837 21.1972C33.4769 21.1321 33.7782 21.2542 33.941 21.5067C34.0958 21.7591 34.0876 22.093 33.9003 22.3292L33.3629 23.0132L34.1039 23.4692C34.3564 23.6321 34.4866 23.9334 34.4215 24.2266C34.3482 24.5197 34.1121 24.7396 33.8107 24.7803L32.9476 24.8862L33.143 25.7331C33.2081 26.0262 33.086 26.3275 32.8336 26.4904C32.5811 26.6451 32.2554 26.637 32.0111 26.4497L31.327 25.9122L30.871 26.6533C30.7407 26.865 30.5127 26.9871 30.2684 26.9871C30.2114 26.9871 30.1625 26.979 30.1137 26.9709C29.8205 26.8976 29.6007 26.6614 29.5599 26.3601L29.4541 25.4969L28.6072 25.6924C28.314 25.7575 28.0127 25.6354 27.8498 25.3829C27.6951 25.1305 27.7033 24.7966 27.8906 24.5604L28.428 23.8764ZM30.0406 23.2332C30.0351 23.2359 30.0296 23.2385 30.0241 23.2411L30.0404 23.2329C30.0404 23.233 30.0405 23.2331 30.0406 23.2332ZM30.0406 23.2332C30.1138 23.3308 30.1707 23.4366 30.187 23.5586C30.2033 23.6808 30.1951 23.8029 30.1544 23.9169C30.2765 23.9332 30.3906 23.9658 30.4883 24.0391C30.586 24.1124 30.6674 24.202 30.7163 24.3078C30.814 24.2345 30.9199 24.1775 31.042 24.1612C31.0827 24.1531 31.1235 24.1531 31.1642 24.1531C31.2456 24.1531 31.3189 24.1694 31.3922 24.1938C31.4085 24.0717 31.4492 23.9577 31.5143 23.8599C31.5876 23.7541 31.6772 23.6726 31.7831 23.6238C31.7098 23.5261 31.6528 23.4202 31.6365 23.2981C31.6202 23.1759 31.6283 23.0456 31.6691 22.9397C31.5469 22.9235 31.441 22.8909 31.3352 22.8176C31.2293 22.7443 31.1479 22.6547 31.099 22.5489C31.0094 22.6222 30.8954 22.6792 30.7733 22.6955C30.6511 22.7199 30.529 22.7117 30.415 22.671C30.3987 22.7932 30.358 22.9072 30.2928 23.0049C30.2311 23.1052 30.1401 23.1836 30.0406 23.2332Z"
        fill="#5B2692"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.6136 29.145L31.8156 28.7948V28.8111C31.5468 28.689 31.3758 28.4039 31.4003 28.1026C31.4247 27.8013 31.6283 27.5489 31.9214 27.4675L32.7602 27.2394L32.4508 26.4251C32.3449 26.1401 32.4182 25.8225 32.6462 25.6271C32.8661 25.4316 33.1999 25.3991 33.4605 25.5456L34.2179 25.9772L34.568 25.1792C34.6902 24.9023 34.967 24.7313 35.2683 24.7557C35.5696 24.7802 35.8221 24.9837 35.9035 25.2769L36.1315 26.1157L36.9377 25.7981C37.2227 25.6922 37.5403 25.7655 37.7358 25.9935C37.9312 26.2134 37.9638 26.5473 37.8172 26.8078L37.3856 27.5652L38.1837 27.9153C38.4605 28.0375 38.6315 28.3144 38.6071 28.6157C38.5827 28.917 38.3791 29.1694 38.0859 29.2508L37.2472 29.4789L37.5566 30.2932C37.6625 30.5782 37.5892 30.8958 37.3612 31.0912C37.1413 31.2867 36.8156 31.3192 36.5468 31.1727L35.7895 30.7411L35.4394 31.5391C35.3416 31.7671 35.1299 31.9219 34.8937 31.9544H34.739C34.4377 31.93 34.1853 31.7264 34.1038 31.4333L33.8758 30.5945L33.0615 30.9121C32.7765 31.0179 32.4589 30.9447 32.2635 30.7166C32.068 30.4968 32.0354 30.1629 32.182 29.9023L32.6136 29.145ZM34.3394 28.0374C34.2824 28.1432 34.201 28.2409 34.1033 28.3061L34.1114 28.3142C34.1928 28.4038 34.2661 28.5015 34.2987 28.6155C34.3394 28.7295 34.3476 28.8598 34.3231 28.9738C34.4371 28.9657 34.5593 28.9901 34.6652 29.0471C34.771 29.1041 34.8687 29.1856 34.9339 29.2833C35.0235 29.1937 35.1212 29.1204 35.2352 29.0878C35.2759 29.0716 35.3166 29.0634 35.3573 29.0634C35.4306 29.0471 35.5121 29.0471 35.5854 29.0634C35.5772 28.9494 35.6098 28.8273 35.6586 28.7214C35.7156 28.6155 35.7971 28.5178 35.8948 28.4527C35.8052 28.3631 35.7319 28.2654 35.6994 28.1514C35.6668 28.0292 35.6586 27.9071 35.6831 27.7931C35.5691 27.8012 35.4469 27.7768 35.3411 27.7198C35.2352 27.6628 35.1375 27.5813 35.0723 27.4836C34.9909 27.565 34.885 27.6383 34.771 27.6709C34.657 27.7116 34.5349 27.7198 34.4127 27.6953C34.4209 27.8093 34.3883 27.9315 34.3394 28.0374Z"
        fill="#5B2692"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.8971 22.443L21.1561 21.987H21.1479C20.9036 21.8242 20.7733 21.5229 20.8385 21.2297C20.9036 20.9365 21.1398 20.7167 21.4411 20.6759L22.3043 20.5701L22.1088 19.7232C22.0437 19.43 22.1658 19.1287 22.4183 18.9658C22.6707 18.8111 23.0046 18.8193 23.2407 19.0066L23.9248 19.544L24.3808 18.803C24.5437 18.5505 24.845 18.4202 25.1381 18.4854C25.4313 18.5587 25.6512 18.7948 25.6919 19.0961L25.7977 19.9593L26.6447 19.7639C26.9378 19.6987 27.2391 19.8209 27.402 20.0733C27.5567 20.3258 27.5486 20.6597 27.3613 20.8958L26.8238 21.5799L27.5648 22.0359C27.8173 22.1987 27.9476 22.5001 27.8824 22.7932C27.8173 23.0864 27.5811 23.3062 27.2798 23.347L26.4166 23.4528L26.6121 24.2997C26.6772 24.5929 26.5551 24.8942 26.3026 25.0571C26.0502 25.2118 25.7245 25.2036 25.4802 25.0163L24.7961 24.4789L24.3401 25.2199C24.2098 25.4316 23.9818 25.5538 23.7375 25.5538C23.6805 25.5538 23.6316 25.5457 23.5828 25.5375C23.2896 25.4642 23.0697 25.2281 23.029 24.9268L22.9232 24.0636L22.0762 24.259C21.7831 24.3242 21.4818 24.202 21.3189 23.9496C21.1642 23.6971 21.1723 23.3632 21.3596 23.1271L21.8971 22.443ZM23.5014 21.8C23.4959 21.8027 23.4904 21.8053 23.4849 21.8079L23.5012 21.7997C23.5012 21.7998 23.5013 21.7999 23.5014 21.8ZM23.5014 21.8C23.5746 21.8976 23.6315 22.0034 23.6478 22.1255C23.6641 22.2476 23.6559 22.3698 23.6152 22.4838C23.7373 22.5001 23.8514 22.5326 23.9491 22.6059C24.0468 22.6792 24.1282 22.7688 24.1771 22.8746C24.2748 22.8014 24.3807 22.7444 24.5028 22.7281C24.5435 22.7199 24.5842 22.7199 24.625 22.7199C24.7064 22.7199 24.7797 22.7362 24.853 22.7606C24.8693 22.6385 24.91 22.5245 24.9751 22.4268C25.0484 22.3209 25.138 22.2395 25.2439 22.1906C25.1706 22.0929 25.1136 21.987 25.0973 21.8649C25.081 21.7427 25.0891 21.6124 25.1299 21.5066C25.0077 21.4903 24.9018 21.4577 24.796 21.3844C24.6901 21.3111 24.6087 21.2215 24.5598 21.1157C24.4702 21.189 24.3562 21.246 24.2341 21.2623C24.1119 21.2867 23.9898 21.2786 23.8758 21.2378C23.8595 21.36 23.8188 21.474 23.7536 21.5717C23.6919 21.6721 23.6009 21.7505 23.5014 21.8Z"
        fill="#5B2692"
      />
      <path
        d="M36.4003 35.5781V43.4527C36.4003 44.267 36.3025 45.057 36.1234 45.7817C35.4556 48.4446 33.6885 50.342 31.6039 50.342H25.3905C22.7358 50.342 20.5859 47.2556 20.5859 43.4527V35.5781H36.3921H36.4003Z"
        fill="#270047"
      />
      <path
        d="M31.7749 53.7949C31.4654 53.8763 31.1315 53.8682 30.814 53.7949L12.2065 48.8682C11.1723 48.5913 10.5534 47.5327 10.8302 46.4985C11.1071 45.4642 12.1657 44.8454 13.1999 45.1222L31.0745 49.8535L37.2146 46.6043C38.1592 46.1076 39.3319 46.4659 39.8368 47.4105C40.3335 48.3551 39.9752 49.5278 39.0306 50.0327L32.2146 53.6401C32.0762 53.7134 31.9214 53.7704 31.7749 53.8112V53.7949Z"
        fill="#D4916D"
      />
      <path
        d="M2.67067 44.4461H12.7277C12.7277 44.4461 12.7521 44.4461 12.7602 44.4461C13.0534 44.4461 13.3384 44.495 13.6072 44.5764C13.6642 44.5927 13.7212 44.609 13.7782 44.6253L29.9834 50.4478L34.9752 46.7425C35.6756 46.2214 36.6609 46.368 37.1821 47.0683C37.7032 47.7686 37.5567 48.7539 36.8563 49.2751L30.9769 53.6399C30.871 53.7214 30.757 53.7784 30.6348 53.8272C30.5615 53.8598 30.4964 53.8924 30.4231 53.9168C30.4231 53.9168 30.4231 53.9168 30.415 53.9168C30.2847 53.9738 29.9182 54.0308 29.6984 53.9901C29.6088 53.982 29.5192 53.9657 29.4296 53.9412L12.1332 50.7165C12.0518 50.7002 11.9785 50.6839 11.8971 50.6595H2.67881C2.67881 50.6595 2.65438 50.6595 2.64624 50.6595C0.944286 50.6432 -0.431935 49.2588 -0.423792 47.5487C-0.423792 45.8305 0.968716 44.438 2.68696 44.438L2.67067 44.4461Z"
        fill="#F8C797"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.29589 51.0913C6.88872 51.0913 6.56299 51.417 6.56299 51.8242C6.56299 52.2314 6.88872 52.5571 7.29589 52.5571C7.70305 52.5571 8.02879 52.2314 8.02879 51.8242C8.02879 51.417 7.70305 51.0913 7.29589 51.0913ZM7.45123 51.8731C7.51638 51.8731 7.57338 51.9301 7.57338 51.9953C7.57338 52.0604 7.51638 52.1174 7.45123 52.1174C7.38608 52.1174 7.32908 52.0604 7.32908 51.9953C7.32908 51.9301 7.38608 51.8731 7.45123 51.8731ZM7.26355 51.653C7.26355 51.5879 7.20654 51.5309 7.1414 51.5309C7.07625 51.5309 7.01925 51.5879 7.01925 51.653C7.01925 51.7182 7.07625 51.7752 7.1414 51.7752C7.20654 51.7752 7.26355 51.7182 7.26355 51.653Z"
        fill="#270047"
      />
      <path
        d="M-4.38963 44.2263L-4.41406 54.5195H9.18529L9.20972 44.2345L-4.38963 44.2263Z"
        fill="#270047"
      />
      <circle cx="49.6165" cy="54.2181" r="5.51303" fill="#FF6800" />
      <path
        d="M46.7012 55.3095H46.0986V54.6336H46.6117C46.6035 54.5033 46.6035 54.373 46.6035 54.2264V54.1043H46.0986V53.4284H46.6524C46.8804 51.8893 47.8006 50.9609 49.4618 50.9609C51.1231 50.9609 51.8967 51.8241 52.1491 52.9398L50.724 53.3062C50.5856 52.671 50.2517 52.3372 49.6003 52.3372C48.9488 52.3372 48.6149 52.6955 48.5172 53.4284H50.3006V54.1043H48.4846V54.6336H49.812V55.3095H48.5661C48.7045 55.8551 49.0384 56.0668 49.6084 56.0668C50.2924 56.0668 50.6426 55.7411 50.7322 54.9023L52.1898 55.1466C52.0025 56.6368 51.0416 57.4593 49.4374 57.4593C47.8332 57.4593 46.9781 56.7346 46.7012 55.3095Z"
        fill="white"
      />
    </g>
  </svg>
</template>
